import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Label, Menu, Icon } from 'semantic-ui-react';
import i18next from 'i18next';
import { hasBusinessPermission } from '../../../helpers/permissions';
import { getActiveOrders, getCurrentRestaurant } from '../../../selectors';

const BranchMenuItems = ({ branchId, iconOnly, match, location }) => {
    const orders = useSelector(state => getActiveOrders(state));
    const restaurant = useSelector(state => getCurrentRestaurant(state));

    const pathname = `/restaurant/${branchId}`;

    function renderDetailsMenuItem() {
        const title = i18next.t('navDetailsTitle');
        const active = location.pathname === pathname;

        return (
            <Menu.Item key="details" as={Link} active={active} to={pathname} name={title}>
                <Icon name='info circle' color='grey' />
                {iconOnly ? null : title}
            </Menu.Item>
        );
    }

    function renderOrderMenuItem() {
        if (!hasBusinessPermission('orders')) return null;

        const title = i18next.t('navOrdersTitle');
        const active = location.pathname.startsWith(pathname + '/orders') || location.pathname.startsWith(pathname + '/subscriptions');
        const ordersCount = orders.filter(order => order.closeDate === null).length;

        return (
            <Menu.Item key="orders" as={Link} active={active} to={pathname + '/orders'}>
                {ordersCount && !iconOnly ? <Label color='teal'>{ordersCount}</Label> : <Icon name='bullhorn' color='grey' />}
                {iconOnly ? null : title}
            </Menu.Item>
        );
    }

    function renderCatalogMenuItem() {
        if (!hasBusinessPermission('menu')) return null;

        const title = i18next.t('navMenuTitle');
        const active = location.pathname.startsWith(pathname + '/menu');

        return (
            <Menu.Item key="menu" as={Link} active={active} to={pathname + '/menu-editor'}>
                <Icon name='book' color='grey' />
                {iconOnly ? null : title}
            </Menu.Item>
        );
    }

    function renderTestOrderMenuItem() {
        if (!hasBusinessPermission('menu')) return null;

        const title = i18next.t('navTestOrderTitle');
        const active = location.pathname.startsWith(pathname + '/testOrder');

        return (
            <Menu.Item key="testOrder" as={Link} active={active} to={pathname + '/testOrder'}>
                <Icon name='lab' color='grey' />
                {iconOnly ? null : title}
            </Menu.Item>
        );
    }

    function renderMarketingMenuItem() {
        if (!hasBusinessPermission('marketing')) return null;

        const title = i18next.t('navMarketingToolTitle');
        const active = location.pathname.startsWith(pathname + '/marketing');

        return (
            <Menu.Item key="marketing" as={Link} active={active} to={pathname + '/marketing'}>
                <Icon name='paint brush' color='grey' />
                {iconOnly ? null : title}
            </Menu.Item>
        );
    }

    function renderKiosksMenuItem() {
        if (!hasBusinessPermission('kiosks')) return null;

        const title = i18next.t('navKiosksTitle');
        const active = location.pathname.startsWith(pathname + '/kiosks');

        return (
            <Menu.Item key="kiosks" as={Link} active={active} to={pathname + '/kiosks'}>
                <Icon name='tablet alternate' color='grey' />
                {iconOnly ? null : title}
            </Menu.Item>
        );
    }

    function renderLocalesMenuItem() {
        if (!hasBusinessPermission('marketing')) return null;

        const title = i18next.t('localesTitle');
        const active = location.pathname.startsWith(pathname + '/locales');

        return (
            <Menu.Item key="locales" as={Link} active={active} to={pathname + '/locales'}>
                <Icon name='translate' color='grey' />
                {iconOnly ? null : title}
            </Menu.Item>
        );
    }

    function renderAnalysisMenuItem() {
        if (!hasBusinessPermission('reports')) return null;

        const title = i18next.t('reportsDashboard');
        const active = location.pathname.startsWith(pathname + '/metabase');

        return (
            <Menu.Item key="metabase" as={Link} active={active} to={pathname + '/metabase'}>
                <Icon name='line graph' color='grey' />
                {iconOnly ? null : title}
            </Menu.Item>
        );
    }

    function renderDeliveryMenuItem() {
        if (!hasBusinessPermission('delivery')) return null;

        const title = i18next.t('navDeliveryTitle');
        const active = location.pathname.startsWith(pathname + '/delivery');

        return (
            <Menu.Item key="delivery" as={Link} active={active} to={pathname + '/delivery'}>
                <Icon name='truck' color={restaurant && restaurant.supportCartOrderDelivery ? 'green' : 'red'} />
                {iconOnly ? null : title}
            </Menu.Item>
        );
    }

    return (
        <Fragment>
            {renderDetailsMenuItem()}
            {renderOrderMenuItem()}
            {renderCatalogMenuItem()}
            {renderTestOrderMenuItem()}
            {renderMarketingMenuItem()}
            {renderKiosksMenuItem()}
            {renderLocalesMenuItem()}
            {renderAnalysisMenuItem()}
            {renderDeliveryMenuItem()}
        </Fragment>
    );
};

BranchMenuItems.propTypes = {
    branchId: PropTypes.string,
    
    match: PropTypes.any,
    location: PropTypes.any,
    iconOnly: PropTypes.bool,
};

export default BranchMenuItems;
